import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ScreenLoaderComponent } from './shared/components/screen-loader/screen-loader.component';
import { EmptyComponent } from './shared/components/empty/empty.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ClickOutsideDirective } from './shared/directives/click-outside.directive';
import { ScreenSizeTrackerDirective } from './shared/directives/screen-size-tracker.directive';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { GlobalErrorHandler } from './core/classes/global-error-handler';
import { LayoutComponent } from './layout/layout/layout.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    LayoutComponent,
    ScreenLoaderComponent,
    ConfirmDialogModule,
    EmptyComponent,
    ClickOutsideDirective,
    ScreenSizeTrackerDirective,
    ToastModule,
  ],
  bootstrap: [AppComponent],
  providers: [MessageService, provideAnimations(), { provide: ErrorHandler, useClass: GlobalErrorHandler }],
})
export class AppModule {}
